<template>
	<div class="margin-top-100 bg-img-2" style="padding:100px 0;">
		<div class="text-center f38 dark-1 f-lq divider-green">最新供需</div>
		<div class="text-center f24 f-thin dark-3">Latest Supply & Demand</div>
		<div class="margin-top-50 margin-auto" style="width: 1100px;">
			<el-row :gutter="20">
				<el-col :span="12">
					<div class="hand hy-data-item text-center" style="padding:20px 0;" :class="{on:searchForm.akey === 'supply'}" @click="changeIndex('supply')">
						<div class="text-center f38 dark-1 title f-lq">供应</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="hand hy-data-item text-center" style="padding:20px 0;" :class="{on:searchForm.akey === 'demand'}" @click="changeIndex('demand')">
						<div class="text-center f38 dark-1 title f-lq">需求</div>
					</div>
				</el-col>
			</el-row>
			<div style="margin-top:30px;height: 580px;">
				<template v-if="list.length > 0">
					<div class="cl margin-bottom-20 hand hide" style="padding:15px;height:100px;background-color: #fff;" v-for="(item,index) in list" @click="$router.push({path:'/supplyDemand/detail/'+item.id})">
						<div class="z hide" style="width: 100px;height: 70px;border-right: 1px solid #ccc;">
							<div class="dark-2 f28" style="line-height: 40px">{{$moment(item.create_time).format('DD')}}</div>
							<div class="dark-3 f14" style="line-height: 20px">{{$moment(item.create_time).format('YYYY.M')}}</div>
						</div>
						<div class="z padding-left-right-30 hide" style="width: 900px;height: 70px;">
							<div class="f18 text-line-2 f-b" style="line-height: 20px;">{{item.title}}</div>
							<div class="f14 dark-3 text-line-1 margin-top" style="line-height: 20px;">{{item.content}}</div>
						</div>
						<div class="y f30 dakr-2" style="line-height: 70px;">&gt;</div>
					</div>
				</template>
				<template v-else>
					<div class="flex flex-ai flex-jc" style="height: 100%;background-color: #fff;">
						<el-empty></el-empty>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "supply",
	data() {
		return {
			list:[],
			searchForm:{
				orderBy:'sort desc,create_time',
				sortBy:'desc',
				limit:5,
				akey:'supply'
			}
		}
	},
	created() {
	},
	mounted() {
		this.getList();
	},
	methods: {
		changeIndex(akey){
			this.searchForm.akey = akey;
			this.getList();
		},
		getList(){
			let _this = this;
			this.$http.post({
				url: '/Supply/listAll',
				data: this.searchForm,
				success(res) {
					_this.list = res;
				}
			});
		},
	}
}
</script>
<style scoped>
.hy-data-item {
	background: #fff;
	border-radius: 10px;
	border:1px solid #eee;
}

.hy-data-item.on, .hy-data-item:hover {
	background: #7ED321;
	border:1px solid #7ED321;
}

.hy-data-item.on .title, .hy-data-item:hover .title {
	color: #fff;
}

.hy-data-item.on .img, .hy-data-item:hover .img {
	background: #fff !important;
}
</style>
